module.exports = __webpack_public_path__ + "img/FR12978.b26b5462.png";